import { hasElement } from '../../dev';

/* STATIC IMPORTS */

// static imports which should be loaded
// every time the app is loaded
// static imports has moved to ./client/src/styles/app.scss to minimize cls
import './components/m/anchor-navigation';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

/* DYNAMIC IMPORTS */

// ATOMS
if (hasElement('.tooltip_container')) {
  import('./components/m/tooltip');
}
if (hasElement('.dialog-overlay')) {
  import('./components/a/dialog-overlay');
}
if (hasElement('iframe')) {
  import('./components/a/iframe');
}
if (hasElement('.dropdown')) {
  import('./components/a/dropdown');
}
if (hasElement('.complex-table')) {
  import('./components/a/table');
}
// MOLECULES
if (hasElement('.simple-text-media-element')) {
  import('./components/m/simple-text-media-element');
}
if (hasElement('.blog-article-teaser-element')) {
  import('./components/m/blog-article-teaser-element');
}
if (hasElement('.simple-text-tiles-element')) {
  import('./components/m/simple-text-tiles-element');
}
if (hasElement('.special-hotspot-element')) {
  import('./components/m/special-hotspot-element');
}
if (hasElement('.modal')) {
  import('./components/m/modal');
}
if (hasElement('.special-product-promotion-element')) {
  import('./components/m/special-product-promotion-element');
}
if (hasElement('.prominent-image-text-marker-element')) {
  import('./components/m/prominent-image-marker-element');
}
if (hasElement('.prominent-text-media-element')) {
  import('./components/m/prominent-text-media-element');
}
if (hasElement('.sticky-service-links')) {
  import('./components/m/sticky-service-links');
}
if (hasElement('.prominent-image-text-marker-overlay-element')) {
  import('./components/m/prominent-img-markeroverlay-element');
}
if (hasElement('.customer-logos-element')) {
  import('./components/m/customer-logos-element');
}
if (hasElement('.prominent-gallery-stripe-element')) {
  import('./components/m/prominent-gallery-stripe');
}
if (hasElement('.tabs-icon-text-element')) {
  import('./components/m/tabs-icon-text-element');
}
if (hasElement('.special-timeline-element')) {
  import('./components/m/special-timeline');
}
if (hasElement('.tabs-text-element')) {
  import('./components/m/tabs-text-element');
}
if (hasElement('.prominent-image-grid')) {
  import('./components/m/prominent-image-grid');
}
if (hasElement('.quotes')) {
  import('./components/m/quotes');
}
if (hasElement('.header__search-autocomplete')) {
  import('./components/m/search/autocomplete');
}
if (hasElement('.search-results')) {
  import('./components/m/search/results');
}
if (hasElement('.blog')) {
  import('./components/o/blog');
}
if (hasElement('.newsletter-subscription-element')) {
  import('./components/m/newsletter-subscription-element');
}
if (hasElement('.user-report-overview-element')) {
  import('./components/m/user-reports-element');
}
if (hasElement('.references-page-detail')) {
  import('./components/m/prominent-text-media-element');
}
if (hasElement('.subforms-element')) {
  import('./components/m/subform-element');
}
// ORGANISMS
if (hasElement('.header')) {
  import('./components/o/header');
}
if (hasElement('.child-pages-overview-element')) {
  import('./components/m/child-pages-overview-element');
}
if (hasElement('.case-studies-element')) {
  import('./components/o/case-studies');
}
if (hasElement('.press')) {
  import('./components/o/press');
}
